var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnapchat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0066 22.0087C14.1031 22.007 14.7276 21.1283 16.1076 20.5164C17.3402 19.9697 19.1036 20.7952 19.4696 19.332C19.5167 18.576 20.8462 18.6976 21.5918 18.1816C22.2722 17.7116 22.3401 16.9572 21.6411 16.6603C20.0596 15.9881 18.3964 14.5156 17.9943 12.9368C17.7428 11.9523 20.8857 11.6494 20.2316 9.79227C19.8454 8.69663 18.4577 9.08229 17.7028 9.32772C18.2057 5.43381 16.3103 1.9913 12 1.9913C7.68978 1.9913 5.79432 5.43381 6.29722 9.32772C5.54232 9.08229 4.15469 8.69663 3.76848 9.79227C3.11383 11.6494 6.25668 11.9523 6.00577 12.9368C5.60367 14.5156 3.94049 15.9881 2.35838 16.6603C1.65991 16.9572 1.72784 17.7116 2.40769 18.1821C3.15382 18.6982 4.48283 18.5766 4.53049 19.3326C4.89644 20.7952 6.65987 19.9697 7.89247 20.5164C9.27298 21.1283 9.89695 22.007 11.9935 22.0087H12.0066Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapchat);
export default __webpack_public_path__ + "static/media/snapchat.aefd84bafc000c18acf280d498d3ac13.svg";
export { ForwardRef as ReactComponent };